// ** React Imports
import { Box, Button, Typography } from '@mui/material';
import Link from 'next/link';

const NotAuthorized = () => {
  return (
    <Box className="content-center">
      <Box
        sx={{
          p: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography sx={{ mb: 2.5 }} variant="h1">
          401
        </Typography>
        <Typography
          sx={{
            mb: 2.5,
            letterSpacing: '0.18px',
            fontSize: '1.5rem !important',
          }}
          variant="h5"
        >
          You are not authorized!
        </Typography>
        <Typography variant="body2">
          You don&prime;t have permission to access this page. Go Home!
        </Typography>
        <Link href="/" passHref legacyBehavior>
          <Button component="a" sx={{ px: 5.5, mt: 4 }} variant="contained">
            Back to Home
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default NotAuthorized;
